// src/pages/meeting/InvitationEGM_ENPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import InvitationEGM3_ENForm from "../../forms/anounce/InvitationEGM3_EN/InvitationEGM3_EN";

function InvitationEGM3_ENPage() {
  return (
    <FormWrapper
  title="ประกาศเลิกบริษัทEnglishขั้นตอน3"
  FormComponent={InvitationEGM3_ENForm}
  formKey="invitation-egm-3-en"
/>

  );
  }

export default InvitationEGM3_ENPage;
